export const SET_TRANSACTION_CATEGORIES = 'SET_TRANSACTION_CATEGORIES';
export const SET_TRANSACTION_CATEGORY = 'SET_TRANSACTION_CATEGORY';
export const ADD_TRANSACTION_CATEGORY = 'ADD_TRANSACTION_CATEGORY';
export const UPDATE_TRANSACTION_CATEGORY = 'UPDATE_TRANSACTION_CATEGORY';
export const REMOVE_TRANSACTION_CATEGORY = 'REMOVE_TRANSACTION_CATEGORY';
export const CLEAR_TRANSACTION_CATEGORY = 'CLEAR_TRANSACTION_CATEGORY';
export const CLEAR_TRANSACTION_CATEGORIES = 'CLEAR_TRANSACTION_CATEGORIES';
